"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasePage = void 0;

var React = require("react");

var BasePage = /*#__PURE__*/function (_React$Component) {
  _inherits(BasePage, _React$Component);

  var _super = _createSuper(BasePage);

  function BasePage(props) {
    var _this;

    _classCallCheck(this, BasePage);

    _this = _super.call(this, props);
    _this.backButtonVisiable = false;
    var render = _this.render;

    _this.render = function () {
      var toolbarLeft = _this.renderToolbarLeft();

      var toolbarRight = _this.renderToolbarRight();

      return React.createElement(React.Fragment, null, React.createElement("div", {
        className: "tabbable"
      }, _this.title ? React.createElement("h4", {
        className: "pull-left",
        style: {
          margin: "2px 0 0 0"
        }
      }, _this.title) : null, React.createElement("ul", {
        className: "nav nav-tabs"
      }, toolbarLeft.map(function (o, i) {
        return React.createElement("li", {
          key: i,
          className: "pull-left"
        }, o);
      }), React.createElement("li", {
        className: "pull-right"
      }, React.createElement("button", {
        className: "btn btn-primary btn-sm",
        style: {
          display: _this.backButtonVisiable ? null : "none"
        },
        onClick: function onClick() {
          return _this.props.app.back();
        }
      }, React.createElement("i", {
        className: "icon-reply"
      }), React.createElement("span", null, "\u8FD4\u56DE"))), toolbarRight.reverse().map(function (o, i) {
        return React.createElement("li", {
          key: i,
          className: "pull-right"
        }, o);
      }))), render ? render.apply(_assertThisInitialized(_this)) : null);
    };

    return _this;
  }

  _createClass(BasePage, [{
    key: "renderToolbarLeft",
    value: function renderToolbarLeft() {
      return [];
    }
  }, {
    key: "renderToolbarRight",
    value: function renderToolbarRight() {
      return [];
    }
  }]);

  return BasePage;
}(React.Component);

exports.BasePage = BasePage;
